import Vue from "vue";

Vue.component("entity-basic-info-editor", {
    props: ["useModal", "annexId", "party", "contextId"],
    data() {
        return {
            loading: false,
            showModal: false,
            counter: 0,
            currentId: this.contextId,
            partyCode: this.party,
            id: 0,
            referenceNumber: '',
            annexNumbers: [],
            displayOrder: 0,
            definesSymbol: null,
            excluded: false,
            originalName: null,
            isNote: false,
            nameEn: null,
            nameEs: null,
            nameFr: null,
            definesSymbols: null,
            links: [],
            classificationSystem: null,
            classificationSystemInfos: [],
            retrievedClassificationSystemInfos: [],
            currentLanguage: window.currentLanguage,
            reviseClassificationSystem: false,
            reviseMetadata: false,
            language: window.currentLanguage,
            languages: {
                'English': 'EN',
                'French': 'FR',
                'Spanish': 'ES'
            },
            genericTypes: [],
            referenceToDomesticLegislations: [],
            economicSectors: [],
            listApproaches: [],
            listScopes: [],
            explicitCoverageOfSLEs: [],
            withCatchAllList: [],
            alignments: [],
            underlines: [],
            allCaps: [],
            numberings: [],
            genericType: null,
            referenceToDomesticLegislation: null,
            economicSector: null,
            listApproach: null,
            listScope: null,
            explicitCoverageOfSLE: null,
            withCatchAll: null,
            alignment: null,
            underline: null,
            allCap: null,
            numbering: null,
            genericTypeLabel: '',
            referenceToDomesticLegislationLabel: '',
            economicSectorLabel: '',
            listApproachLabel: '',
            listScopeLabel: '',
            explicitCoverageOfSLELabel: '',
            withCatchAllLabel: '',
            alignmentLabel: '',
            underlineLabel: '',
            allCapLabel: '',
            numberingLabel: ''
        };
    },
    methods: {
        initialize(entityId) {
            const self = this;

            self.id = entityId;
            self.loading = true;

            self.$services.entities.getById({
                id: entityId,
                language: window.currentLanguage,
                partyId: self.partyCode
            }).then((data) => {
                console.log(data);
                self.id = data.id;
                self.referenceNumber = data.referenceNumber;
                self.originalName = data.originalName;
                self.excluded = data.excluded;
                self.isNote = data.isNote;
                self.definesSymbol = data.definesSymbol;
                self.nameEn = data.nameEn;
                self.nameEs = data.nameEs;
                self.nameFr = data.nameFr;
                self.displayOrder = data.displayOrder;
                self.links = data.links;
                self.definesSymbols = data.definesSymbols;
                self.retrievedClassificationSystemInfos = data.classificationSystemInfos;
                self.reviseClassificationSystem = false;				
                self.reviseMetadata = false;
                self.genericTypes = data.genericTypes;
                self.genericType = data.genericType;
                self.genericTypeLabel = data.genericTypeLabel;
                self.referenceToDomesticLegislations = data.referenceToDomesticLegislations;
                self.referenceToDomesticLegislation = data.referenceToDomesticLegislation;
                self.referenceToDomesticLegislationLabel = data.referenceToDomesticLegislationLabel;
                self.economicSectors = data.economicSectors;
                self.economicSector = data.economicSector;
                self.economicSectorLabel = data.economicSectorLabel;
                self.listApproaches = data.ListApproaches;
                self.listApproach = data.listApproach;
                self.listApproachLabel = data.listApproachLabel;
                self.listScopes = data.listScopes;
                self.listScope = data.listScope;
                self.listScopeLabel = data.listScopeLabel;
                self.explicitCoverageOfSLEs = data.explicitCoverageOfSLEs;
                self.explicitCoverageOfSLE = data.explicitCoverageOfSLE;
                self.explicitCoverageOfSLELabel = data.explicitCoverageOfSLELabel;
                self.withCatchAllList = data.withCatchAllList;
                self.withCatchAll = data.withCatchAll;
                self.withCatchAllLabel = data.withCatchAllLabel;
                self.alignments = data.alignments;
                self.alignment = data.alignment;
                self.alignmentLabel = data.alignmentLabel;
                self.underlines = data.underlines;
                self.underline = data.underline;
                self.underlineLabel = data.underlineLabel;
                self.allCaps = data.allCaps;
                self.allCap = data.allCap;
                self.allCapLabel = data.allCapLabel;
                self.numberings = data.numberings;
                self.numbering = data.numbering;
                self.numberingLabel = data.numberingLabel;

                self.loading = false;

                if (self.useModal) {
                    self.showModal = true;
                }
            });
        },
        discard() {
            const self = this;

            self.id = 0;
            self.referenceNumber = null;
            self.excluded = false;
            self.originalName = null;
            self.isNote = false;
            self.definesSymbol = null;
            self.nameEn = null;
            self.nameEs = null;
            self.nameFr = null;
            self.displayOrder = 0;
            self.links = [];
            self.classificationSystemInfos = [];
            self.reviseClassificationSystem = false;
            self.reviseMetadata = false;
            self.genericType = null;
            self.referenceToDomesticLegislation = null;
            self.economicSector = null;
            self.listApproach = null;
            self.listScope = null;
            self.explicitCoverageOfSLE = null;
            self.withCatchAll = null;
            self.alignment = null;
            self.underline = null;
            self.allCap = null;
            self.numbering = null;

            self.showModal = false;
        },
        save() {
            const self = this;

            let metadatas = [];

            if (self.reviseMetadata) {                
                if (self.genericType != null && self.genericType > 0) {
                    metadatas.push(self.genericType);
                }

                if (self.referenceToDomesticLegislation != null && self.referenceToDomesticLegislation > 0) {
                    metadatas.push(self.referenceToDomesticLegislation);
                }

                if (self.economicSector != null && self.economicSector > 0) {
                    metadatas.push(self.economicSector);
                }

                if (self.listApproach != null && self.listApproach > 0) {
                    metadatas.push(self.listApproach);
                }

                if (self.listScope != null && self.listScope > 0) {
                    metadatas.push(self.listScope);
                }

                if (self.explicitCoverageOfSLE != null && self.explicitCoverageOfSLE > 0) {
                    metadatas.push(self.explicitCoverageOfSLE);
                }

                if (self.withCatchAll != null && self.withCatchAll > 0) {
                    metadatas.push(self.withCatchAll);
                }

                if (self.alignment != null && self.alignment > 0) {
                    metadatas.push(self.alignment);
                }

                if (self.underline != null && self.underline > 0) {
                    metadatas.push(self.underline);
                }

                if (self.allCap != null && self.allCap > 0) {
                    metadatas.push(self.allCap);
                }

                if (self.numbering != null && self.numbering > 0) {
                    metadatas.push(self.numbering);
                }
            }

            self.$services.entities.save({
                id: self.id,
                referenceNumber: self.referenceNumber,
                originalName: self.originalName,
                isNote: self.isNote,
                definesSymbol: self.definesSymbol,
                excluded: self.excluded,
                nameEn: self.nameEn,
                nameEs: self.nameEs,
                nameFr: self.nameFr,
                displayOrder: self.displayOrder,
                links: self.links,
                classificationSystemInfos: self.classificationSystemInfos,
                reviseClassificationSystem: self.reviseClassificationSystem,
                reviseMetadata: self.reviseMetadata,
                metadataIds: metadatas
            }).then((data) => {
                if (data) {
                    self.counter += 1;
                    self.currentId = self.id + '|1|' + self.counter;

                    self.$emit('update:contextId', self.currentId);

                    self.$buefy.snackbar.open(window.messages.entitySuccessfullyStored);
                    self.id = 0;
                    self.referenceNumber = null;
                    self.excluded = false;
                    self.originalName = null;
                    self.isNote = false;
                    self.definesSymbol = null;
                    self.nameEn = null;
                    self.nameEs = null;
                    self.nameFr = null;
                    self.displayOrder = 0;
                    self.links = [];
                    self.definesSymbols = [];
                    self.classificationSystemInfos = [];
                    self.reviseClassificationSystem = false;
                    self.reviseMetadata = false;
                    self.genericType = null;
                    self.referenceToDomesticLegislation = null;
                    self.economicSector = null;
                    self.listApproach = null;
                    self.listScope = null;
                    self.explicitCoverageOfSLE = null;
                    self.withCatchAll = null;
                    self.alignment = null;
                    self.underline = null;
                    self.allCap = null;
                    self.numbering = null;

                    self.showModal = false;
                }
                else {
                    self.$buefy.snackbar.open(window.messages.entityUnsuccessfullyStored);
                }

                if (self.useModal) {
                    self.showModal = false;
                }
            });
        },
        filterDefinesSymbol(text) {
            const self = this;

            self.definesSymbols = self.definesSymbols.filter((option) => {
                return option.symbol
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        }
    },
    watch: {
        reviseClassificationSystem: function (value) {
            const self = this;

            if (value) {
                self.classificationSystem = self.retrievedClassificationSystem;
                self.classificationSystemInfos = self.retrievedClassificationSystemInfos;

                if (self.annexNumbers.length <= 0) {
                    for (let index = 0; index <= 8; index++) {
                        self.annexNumbers.push({
                            value: index > 0 ? index : null,
                            text: index > 0 ? `Annex ${index}` : window.labels.notApplicable
                        });
                    }
                }
            }
            else {
                self.classificationSystem = null;
                self.classificationSystemInfos = [];
            }
        }
    },
    computed: {
        dataManagementBasicInformationLabel: function () {
            return window.labels.dataManagementBasicInformation;
        },
        dataManagementBasicInfoReferenceNumberLabel: function () {
            return window.labels.dataManagementBasicInfoReferenceNumber;
        },
        dataManagementBasicInfoDisplayOrderLabel: function () {
            return window.labels.dataManagementBasicInfoDisplayOrder;
        },
        dataManagementAnnex6TextLabel: function () {
            return window.labels.dataManagementAnnex6Text;
        },
        dataManagementBasicInfoReviseClassificationSystemLabel: function () {
            return window.labels.dataManagementBasicInfoReviseClassificationSystem;
        },
        dataManagementBasicInfoReviseMetadataLabel: function () {
            return window.labels.dataManagementBasicInfoReviseMetadata;
        },
        dataManagementClassificationSystemLabel: function () {
            return window.labels.dataManagementClassificationSystem;
        },
        dataManagementNoteReferenceAnnexNumberLabel: function () {
            return window.labels.dataManagementNoteReferenceAnnexNumber;
        },
        dataManagementExclusionLabel: function () {
            return window.labels.dataManagementExclusion;
        },
        dataManagementExcludedLabel: function () {
            return window.labels.dataManagementExcluded;
        },
        dataManagementInclusionLabel: function () {
            return window.labels.dataManagementInclusion;
        },
        dataManagementMetadataLabel: function () {
            return window.labels.dataManagementMetadata;
        },
        dataManagementSaveLabel: function () {
            return window.labels.dataManagementSave;
        },
        dataManagementCancelLabel: function () {
            return window.labels.dataManagementCancel;
        },
        dataManagementAnnex1Label: function () {
            return window.labels.dataManagementAnnex1;
        },
        dataManagementHasEntityLinkLabel: function () {
            return window.labels.dataManagementHasEntityLink;
        },
        dataManagementEntityLinkLabel: function () {
            return window.labels.dataManagementEntityLink;
        },
        dataManagementAnnex1NameLabel: function () {
            return window.labels.dataManagementAnnex1Name;
        },
        dataManagementAnnex1OriginalNameLabel: function () {
            return window.labels.dataManagementAnnex1OriginalName;
        },
        dataManagementReviseFormattingMetadataLabel: function () {
            return window.labels.dataManagementReviseFormattingMetadata;
        },
        dataManagementFormattingMetadataLabel: function () {
            return window.labels.dataManagementFormattingMetadata;
        },
        dataManagementFormattingLabel: function () {
            return window.labels.dataManagementFormatting;
        },
        dataManagementAnnexNumberPlaceholderLabel: function () {
            return window.labels.dataManagementAnnexNumberPlaceholder;
        }
    },
    template: `
        <div>
            <b-modal full-screen id="entityFormModal" ref="entityFormModal" :canCancel="false" v-model="showModal">
                <div class="modal-card" style="overflow-y: auto;">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{dataManagementAnnex1Label}}</p>
                        <button type="button" class="delete" @click="discard"/>
                    </header>
                    <section class="modal-card-body">
                        <div class="card">                        
                            <div class="card-content">                            
                                <template v-if="loading"><loading></loading></template>
                                <template v-else>
                                    <div class="content">
                                        <fieldset class="box">
                                            <legend class="label has-text-centered section-legend">{{dataManagementBasicInformationLabel}}</legend>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field :label="dataManagementBasicInfoReferenceNumberLabel">
                                                        <b-input v-model="referenceNumber"></b-input>
                                                    </b-field>
                                                </div>
                                                <div class="column">
                                                    <b-field :label="dataManagementBasicInfoDisplayOrderLabel">
                                                        <b-numberinput v-model="displayOrder"></b-numberinput>
                                                    </b-field>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field :label="dataManagementHasEntityLinkLabel">
                                                        <b-checkbox v-model="isNote"></b-checkbox>
                                                    </b-field>
                                                </div>
                                                <div class="column">
                                                    <b-field :label="dataManagementEntityLinkLabel" v-if="isNote">
                                                        <b-input v-model="definesSymbol"></b-input>
                                                    </b-field>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
												    <toggle-switch :values="languages" :selected.sync="language" default="currentLanguage"></toggle-switch>
											    </div>
											    <div class="column">
												    <b-field :label="dataManagementExcludedLabel">
													    <b-checkbox v-model="excluded"></b-checkbox>
												    </b-field>
											    </div>
										    </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field :label="dataManagementAnnex1NameLabel">
												        <b-input v-model="nameEn" v-if="language == 'English'"></b-input>
												        <b-input v-model="nameFr" v-if="language == 'French'"></b-input>
												        <b-input v-model="nameEs" v-if="language == 'Spanish'"></b-input>
											        </b-field>
                                                </div>
                                            </div>
                                            <div class="columns">
										        <div class="column">
											        <b-field :label="dataManagementAnnex1OriginalNameLabel">
                                                        <b-input v-model="originalName"></b-input>
                                                    </b-field>
										        </div>
									        </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field label="Links">
                                                        <b-taginput
				                                            autocomplete
				                                            v-model="links"
				                                            :data="definesSymbols"
				                                            @typing="filterDefinesSymbol"
				                                            field="symbol"
				                                            :open-on-focus="true">
			                                            </b-taginput>
                                                    </b-field>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div class="columns">
                                            <div class="column">
												<b-field :label="dataManagementBasicInfoReviseClassificationSystemLabel">
													<b-checkbox v-model="reviseClassificationSystem"></b-checkbox>
												</b-field>
											</div>
                                            <div class="column">
												<b-field label="Revise Formatting & Metadata?">
													<b-checkbox v-model="reviseMetadata"></b-checkbox>
												</b-field>
											</div>
                                        </div>
                                        <fieldset class="box" v-if="reviseClassificationSystem">
                                            <legend class="label has-text-centered section-legend">{{dataManagementClassificationSystemLabel}}</legend>
                                            <div class="columns" v-for="classificationSystemInfo in classificationSystemInfos" :key="classificationSystemInfo.id">
										        <div class="column is-8">
                                                    <b-field :label="classificationSystemInfo.displayCode" label-position="on-border">
                                                        <classification-system-items-treeview-select :value.sync="classificationSystemInfo.classificationHierarchyIds" :classification-system-id="classificationSystemInfo.id" :placeholder="'Select ' + classificationSystemInfo.displayCode + ' classification code here'" :language="currentLanguage" guid="'inclusion_' + classificationSystemInfo.code +'_' + classificationSystemInfo.id"></classification-system-items-treeview-select>
                                                    </b-field>
										        </div>
                                                <div class="column is-4">
                                                    <b-field :label="dataManagementNoteReferenceAnnexNumberLabel" label-position="on-border">
                                                        <b-select v-model="classificationSystemInfo.noteReferenceAnnexNumber" :placeholder="dataManagementAnnexNumberPlaceholderLabel" expanded>
                                                            <option v-for="annexNumber in annexNumbers"
                                                                :value="annexNumber.value"
                                                                :key="classificationSystemInfo.id + '_' + annexNumber.value"> {{ annexNumber.text }}</option>
                                                        </b-select>
                                                    </b-field>
										        </div>
									        </div>
                                        </fieldset>
                                        <template v-if="reviseMetadata">
                                            <fieldset class="box">
                                                <legend class="label has-text-centered section-legend">{{dataManagementReviseFormattingMetadataLabel}}</legend>
                                                <fieldset class="box">
                                                    <legend class="label has-text-centered section-legend">{{dataManagementFormattingMetadataLabel}}</legend>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="alignmentLabel">
				                                                <b-select v-model="alignment">
					                                                <option
						                                                v-for="option in alignments"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="underlineLabel">
				                                                <b-select v-model="underline">
					                                                <option
						                                                v-for="option in underlines"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <fieldset class="box">
                                                    <legend class="label has-text-centered section-legend">{{dataManagementMetadataLabel}}</legend>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="genericTypeLabel">
				                                                <b-select v-model="genericType" >
					                                                <option
						                                                v-for="option in genericTypes"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="referenceToDomesticLegislationLabel">
				                                                <b-select v-model="referenceToDomesticLegislation">
					                                                <option
						                                                v-for="option in referenceToDomesticLegislations"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="economicSectorLabel">
				                                                <b-select v-model="economicSector">
					                                                <option
						                                                v-for="option in economicSectors"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="listApproachLabel">
				                                                <b-select v-model="listApproach">
					                                                <option
						                                                v-for="option in listApproaches"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="listScopeLabel">
				                                                <b-select v-model="listScope">
					                                                <option
						                                                v-for="option in listScopes"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="explicitCoverageOfSLELabel">
				                                                <b-select v-model="explicitCoverageOfSLE">
					                                                <option
						                                                v-for="option in explicitCoverageOfSLEs"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="withCatchAllLabel">
				                                                <b-select v-model="withCatchAll">
					                                                <option
						                                                v-for="option in withCatchAllList"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="allCapLabel">
				                                                <b-select v-model="allCap">
					                                                <option
						                                                v-for="option in allCaps"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field class="mb-0 p-0 metadata-control" :label="numberingLabel">
				                                                <b-select v-model="numbering">
					                                                <option
						                                                v-for="option in numberings"
						                                                :value="option.id"
						                                                :key="option.id">
						                                                {{ option.name }}
					                                                </option>
				                                                </b-select>
			                                                </b-field>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </fieldset>   
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </section>
                    <footer class="modal-card-foot buttons">
					    <button type="button" class="button is-primary" @click="save">{{dataManagementSaveLabel}}</button>
					    <button type="button" class="button is-danger" @click="discard">{{dataManagementCancelLabel}}</button>
                    </footer>
                </div>
            </b-modal>            			
		</div>
	`
});